document.querySelector("[name='id']").addEventListener("change", async function(e) {
  const id = e.target.value;
  const productHandle = window.location.pathname.split("/").pop();
  const fetchUrl = `${Shopify.routes.root}products/${productHandle}?variant=${id}&section_id=variant-properties-helper`;

  try {
    const res = await fetch(fetchUrl);
    if (!res.ok) {
      throw new Error(`Fetch error: ${res.statusText}`);
    }
    const text = await res.text();

    const html = new DOMParser().parseFromString(text, "text/html");

    // Variant properties
    const dimensions = html.querySelector("#dimensions")?.innerHTML;
    const cubes = html.querySelector("#cubes")?.innerHTML;
    const weight = html.querySelector("#weight")?.innerHTML;
    const dimensionsEl = document.querySelector("#product-dimensions");
    if (dimensionsEl) dimensionsEl.innerText = dimensions || "-";
    const cubesEl = document.querySelector("#product-cubes");
    if (cubesEl) cubesEl.innerText = cubes || "-";
    const weightEl = document.querySelector("#product-weight");
    if (weightEl) weightEl.innerText = weight || "-";

    // Included items
    const includedItems = html.querySelector("#included-items")?.innerHTML;
    document.querySelector(".included-items").innerHTML = includedItems
        
  } catch (error) {
    console.error("Error fetching variant data:", error);
  }
});
